<template>
  <div class="blockscan-page">
    <el-row class="blockscan-page__row">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
        <p class="page-form-title">Block Page</p>
        <p class="page-form-tip" v-if="total">Total of {{ total }} blocks.</p>
        <el-table
          :data="blocks"
          stripe
          border
          style="width: 100%"
          v-loading="isBlocksLoading"
          :cell-style="cellStyle"
          @cell-click="cellClick"
        >
          <el-table-column prop="height" label="Block">
            <template slot-scope="scope">
              <el-tag type="primary" effect="dark" disable-transitions
                ><i class="el-icon-s-data"></i> {{ scope.row.height }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="transaction_count" label="Transaction Count">
            <template slot-scope="scope">
              <el-tag type="primary" disable-transitions
                ><i class="el-icon-document-copy"></i>
                {{ scope.row.transaction_count }}
                {{
                  scope.row.transaction_count > 1
                    ? 'Transactions'
                    : 'Transaction'
                }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="created_time"
            label="Time"
            :formatter="dateFilters"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="page"
          :page-size="per_page"
          @current-change="getBlocks"
          class="blockscan-page__pagination"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import format from 'date-fns/format'

export default {
  name: 'block-scan-page',

  data() {
    return {
      blocks: undefined,
      isBlocksLoading: true,
      total: null,
      per_page: 15,
      page: 1
    }
  },

  methods: {
    onSearchBlock(block) {
      this.$router.push({
        name: 'block-page',
        query: { height: block }
      })
    },
    getBlocks() {
      this.isBlocksLoading = true

      this.$axios({
        method: 'get',
        url: '/api/blocks',
        params: {
          page: this.page,
          per_page: this.per_page
        }
      })
        .then((response) => {
          this.total = parseInt(response.headers['x-total'])
          this.blocks = response.data
          this.isBlocksLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isBlocksLoading = false
        })
    },
    dateFilters(row, column) {
      const date = row.created_time || row.time
      return date
        ? format(date * 1000, 'MMMM d, yyyy HH:mm:ss')
        : 'Initial block'
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      switch (column.property) {
        case 'txid':
          return 'font-weight: 700; cursor: pointer;'
        case 'block_height':
          return 'cursor: pointer;'
        case 'height':
          return 'cursor: pointer;'
        case 'transaction_count':
          return 'cursor: pointer;'

        default:
          break
      }
    },
    cellClick(row, column, cell, event) {
      switch (column.property) {
        case 'block_height':
          this.onSearchBlock(row.block_height)
          break

        case 'height':
          this.onSearchBlock(row.height)
          break

        case 'txid':
          this.onSearchTransaction(row.txid)
          break

        case 'transaction_count':
          this.$router.push({
            name: 'transactions-page',
            query: {
              height: row.height
            }
          })
          break

        default:
          break
      }
    }
  },

  created() {
    this.getBlocks()
  }
}
</script>

<style scoped lang="scss">
.blockscan-page {
  &__row {
    padding: 2rem;
  }
  &__title {
    margin-bottom: 2rem;
    display: block;
  }
  &__pagination {
    margin-top: 2rem;
  }
}
</style>
